export const formatTrayName = (name = "") => {
  if (!name) return "";
 
  const words = name.toLowerCase().split("-");
 
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase() + words[0].slice(1);
  }
 
  return `${words[0].toUpperCase()}-${words[1].charAt(0).toUpperCase()}${words[1].slice(1)}`;
};